var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60411 3.43906C2.77584 2.95061 3.31103 2.69385 3.79948 2.86558L4.17623 2.99804C4.94689 3.26895 5.60143 3.49905 6.11654 3.7518C6.66733 4.02205 7.13964 4.35497 7.49487 4.8748C7.84734 5.3906 7.99287 5.9565 8.06003 6.57697C8.09009 6.85472 8.10595 7.16215 8.11432 7.50006H21.4121C23.5183 7.50006 25.4142 7.50006 25.9692 8.22141C26.5241 8.94277 26.3071 10.0297 25.8732 12.2035L25.2486 15.2344C24.8547 17.1455 24.6577 18.1011 23.9681 18.6631C23.2784 19.2251 22.3028 19.2251 20.3515 19.2251H13.7229C10.2368 19.2251 8.49369 19.2251 7.41068 18.0828C6.32768 16.9405 6.24864 15.727 6.24864 12.0501L6.24864 8.79796C6.24864 7.87303 6.24736 7.25401 6.19592 6.77875C6.14676 6.32456 6.05963 6.09778 5.9468 5.93268C5.83673 5.7716 5.66964 5.62106 5.29061 5.43508C4.88705 5.23707 4.33861 5.04263 3.5041 4.74924L3.17759 4.63444C2.68913 4.46271 2.43237 3.92752 2.60411 3.43906Z",
    fill: "url(#paint0_linear_2489_70008)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3739 22.5001C10.4094 22.5001 11.2489 23.3395 11.2489 24.3751C11.2489 25.4106 10.4094 26.2501 9.3739 26.2501C8.33837 26.2501 7.4989 25.4106 7.4989 24.3751C7.4989 23.3395 8.33837 22.5001 9.3739 22.5001Z",
    fill: "url(#paint1_linear_2489_70008)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6239 22.5002C21.6594 22.5002 22.4989 23.3396 22.4989 24.3752C22.4989 25.4107 21.6594 26.2502 20.6239 26.2502C19.5884 26.2502 18.7489 25.4107 18.7489 24.3752C18.7489 23.3396 19.5884 22.5002 20.6239 22.5002Z",
    fill: "url(#paint2_linear_2489_70008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2489_70008",
    x1: 15.9662,
    y1: 2.81226,
    x2: 15.9662,
    y2: 26.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2489_70008",
    x1: 15.9662,
    y1: 2.81226,
    x2: 15.9662,
    y2: 26.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2489_70008",
    x1: 15.9662,
    y1: 2.81226,
    x2: 15.9662,
    y2: 26.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.53ac9ac1346235cad00e95e9cb9b1279.svg";
export { ForwardRef as ReactComponent };